// extracted by mini-css-extract-plugin
export default {"ProxyTag":"ProxyTag_ProxyTag__Y0xIH"};